import apiConfig from "src/utils/apiConfig";

export const FETCH_CORPORATE = "corporate/fetchCorporateListRequest";
export const GET_COMPANYID = "corporate/fetchCompanyIdRequest";
export const ADD_CORPORATE = "corporate/addCorporateRequest";
export const EDIT_CORPORATE = "corporate/editEnterprisesRequest";

export const fetchCorporate = (
  fromdate?: string,
  todate?: string,
  filter?: string,
  limit?: number,
  skip?: number
) => {
  let endpoint = `${apiConfig.FETCHCORPORATE}/?fromdate=${fromdate}&todate=${todate}`;

  if (filter && filter.trim() !== "") {
    endpoint += `&filter=${encodeURIComponent(filter.trim())}`;
  }
  if (limit !== undefined) {
    endpoint += `&limit=${limit}`;
  }
  if (skip !== undefined) {
    endpoint += `&skip=${skip}`;
  }

  const apiobject = {
    method: "GET",
    authentication: true,
    endpoint,
  };

  return {
    type: FETCH_CORPORATE,
    payload: apiobject,
  };
};

export const AddCorporate = (payload: any) => {
  const apiObject: any = {
    method: 'POST',
    authentication: true,
    endpoint: apiConfig.ADDCORPORATE,
    body: payload,
  };
  return {
    type: ADD_CORPORATE,
    payload: apiObject,
  };
};

export const GetCompanyId = () => {
  const apiObject: any = {
    method: 'GET',
    authentication: true,
    endpoint: apiConfig.GETCOMPANYID,
  };
  return {
    type: GET_COMPANYID,
    payload: apiObject,
  };
};

export const EditEnterprises = (payload: any) => {
  const apiObject: any = {
    method: 'POST',
    authentication: true,
    endpoint: apiConfig.EDITCORPORATE,
    body: payload,
  };
  return {
    type: EDIT_CORPORATE,
    payload: apiObject,
  };
};
